import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  submit() {
    clearTimeout(this.timeout)
    this.form?.requestSubmit()
  }

  submitWithDelay() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.form?.requestSubmit()
    }, this.delayValue)
  }

  get form() {
    return this.element.tagName === "FORM" ? this.element : this.element.form
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
